// extracted by css-extract-rspack-plugin
export default {"configGrid":"QE6Am1w80qv6LYEK"};